var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "64px",
    viewBox: "0 0 1016 217",
    style: {
      enableBackground: "new 0 0 1016 217"
    },
    xmlSpace: "preserve",
    preserveAspectRatio: "xMinYMin none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B31F24;}\n\t.st1{fill:#431512;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.6,97.2c23.2-9.4,31.8-22.1,31.8-37.8c0-27.4-23.9-39.6-63.1-39.6h-70.1c4.4,6.7,8.6,13.9,8.6,24.7v54.4   c-20.6,4.1-39.1,7.6-56.5,11.8c-15.6-43-33-90.9-33-90.9H80.7c0.7,6,0.1,12.4-3.1,21.1l-48.8,136c0,0-3.2,9.6-9.9,18.2h35.7   c-0.7-4.7,0.2-10.9,1.4-14.7c3.6-10.7,13.3-17.8,23.6-22.4c13.4-6.1,36.7-13.4,47.7-16.7l11.6,33.2c0,0,4.7,12.5,2.2,20.6h50.4   c-7.6-10.3-10.2-18-10.2-18.2c-1.2-3.2-7.8-21.6-16.3-44.8c15.4-3.7,31.5-6.8,48.8-10.2v48.3c0,9.3-3.8,17.5-8.6,24.8h66.6   c10.9,0,20.6-0.6,27.9-1.9c28.6-5,49.1-19.6,49.1-50.7C348.9,118.6,332.9,104.4,306.6,97.2 M81.4,133.4c-4.2,2-9.6,5.3-12.7,8.4   c9.6-28,22.8-66.5,29.2-84.7l22,62.8C108.8,123.1,91.7,128.5,81.4,133.4z M252.7,41.7c6.9-0.4,9.4-0.4,13.9-0.4   c21.5,0,31.5,9,31.5,21.7c0,12.1-8,19.6-21.3,23.6c-5.6,1.7-14.9,3.6-24.1,5.2V41.7z M268.9,173.3h-16.1v-58.4   c6-1.4,15.6-3.1,21.9-3.8c19.4,4.5,33.7,12.5,33.7,32.3C308.3,166.5,291.4,173.3,268.9,173.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M366.9,195.1c8.6-12.9,8.6-24.6,8.6-24.8V44.7c0-0.2,0-11.8-8.6-24.8h56.3c-8.6,13-8.6,24.6-8.6,24.8v125.6    c0,0.2,0,11.9,8.6,24.8H366.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M997.1,71.7h-37.7c3.2,5.2,1.9,13.5-1.4,21.9l-24.4,65.1l-25.3-65.1c-3.4-8.4-4.6-16.7-1.4-21.9h-48.7    c6.7,7.1,10.9,16.2,13.3,21.9l41.9,101.5H946c0,0,0.8-8.3,4.5-17.6c0,0,0,0,0,0l33.7-83.9C986.5,87.8,991.3,77.8,997.1,71.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M863.2,137c2.4-25.8-4.7-70.7-61.7-70.7c-46.5,0-63.6,32.4-63.6,64c0,40.2,21.9,67.8,74.3,67.8    c21.3,0,38.5-6.3,48.7-12.5l-10.5-23.2c-9.9,5-22,9.4-35.5,9.4c-23.4,0-37.8-8.2-40.9-31.4h50.6    C843.2,140.5,858.3,139.4,863.2,137 M774.1,119.2c2.3-19.9,11.2-30,27.4-30c16.8,0,25.1,13,25.8,29.8c0,0-7.4,0.2-17,0.2H774.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519.5,195.1h49.9c-7.6-11.4-7.6-21.8-7.6-21.9v-65.9c0-23.6-12.7-38.1-39.5-38.1c-17.1,0-31.2,7.7-41.6,17.1    V71.7h-42.4c7.6,11.5,7.6,21.8,7.6,21.9v79.5c0,0.2,0,10.5-7.6,21.9h50c-7.6-11.4-7.6-21.8-7.6-21.9v-65.8    c6.4-6.6,15.5-11.4,25.5-11.4c15.3,0,20.9,8.5,20.9,21.7v55.5C527.1,173.3,527.1,183.6,519.5,195.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M648.8,112.4c24.6,0,38.1,12,38.1,31.4c0,17.4-10.4,30.1-38.7,30.1h-16.9v-61.5H648.8z M645.1,41.1    c21.5,0,31.5,8.4,31.5,24.2c0,15.7-9,25.1-29.7,25.1c-4,0-11.3,0.1-15.6,0V41.1H645.1z M649.6,195.1c10.9,0,21-0.6,28.3-1.9    c28.1-4.9,48.9-19.3,48.9-50.3c0-24.9-15.9-37.8-40.9-45c22.4-8.5,29.9-20.7,29.9-36.6c0-27.4-22.3-41.4-62.5-41.4l-67.2,0    c4.7,7.1,6.3,17.4,6.3,24.8v125.6c0,8.2-1.5,16.8-6.3,24.8H649.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.947d0c02c342e36116d8ed36ef7509f9.svg";
export { ForwardRef as ReactComponent };